import { Button, Dropdown, Label } from '@heroui/react';
import { Segment } from '@heroui-pro/react';
import type { Key } from 'react';
import { IconFileTypeDoc, IconFileTypePpt, IconPlus } from '@tabler/icons-react';

export type KnowledgeBasesScope = 'my' | 'shared';

export type KnowledgeBaseHeaderProps = {
  scope: KnowledgeBasesScope;
  onScopeChange: (key: Key) => void;
  onNewDoc: () => void;
  onNewSlides: () => void;
};

/** 知识库列表顶栏：范围切换 + 新建文档/幻灯片 */
export function KnowledgeBaseHeader({
  scope,
  onScopeChange,
  onNewDoc,
  onNewSlides,
}: KnowledgeBaseHeaderProps) {
  return (
    <div className="flex shrink-0 items-center justify-between gap-3 border-b border-divider p-4">
      <div className="shrink-0">
        <Segment className="w-fit shrink-0" selectedKey={scope} onSelectionChange={onScopeChange}>
          <Segment.Item id="my">
            <Segment.Separator />
            我的
          </Segment.Item>
          <Segment.Item id="shared">
            <Segment.Separator />
            共享
          </Segment.Item>
        </Segment>
      </div>
      <div className="shrink-0">
        <Dropdown>
          <Button className="gap-1.5">
            <IconPlus className="size-4 shrink-0" stroke={2} />
            新建
          </Button>
          <Dropdown.Popover placement="bottom end" offset={8}>
            <Dropdown.Menu>
              <Dropdown.Item id="new-doc" textValue="新建文档" onAction={() => void onNewDoc()}>
                <Label className="flex w-full items-center gap-2 font-normal">
                  <IconPlus className="size-4 shrink-0 text-foreground" stroke={2} />
                  <span className="flex-1 text-left text-sm">新建文档</span>
                  <IconFileTypeDoc className="size-5 shrink-0 text-muted-foreground" stroke={1.5} />
                </Label>
              </Dropdown.Item>
              <Dropdown.Item id="new-slides" textValue="新建幻灯片" onAction={onNewSlides}>
                <Label className="flex w-full items-center gap-2 font-normal">
                  <IconPlus className="size-4 shrink-0 text-foreground" stroke={2} />
                  <span className="flex-1 text-left text-sm">新建幻灯片</span>
                  <IconFileTypePpt className="size-5 shrink-0 text-muted-foreground" stroke={1.5} />
                </Label>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown.Popover>
        </Dropdown>
      </div>
    </div>
  );
}
